// OpenAI Assistant models generate inline citations of the format 【...†...】
// They intend the caller to then replace these with whatever text is preferred, e.g a footnote [0]
// This helper just removes all instances of inline citations.
const removeCitationText = (message: string) => {
  return message.replace(/【[^【】]*】/g, "");
};

// We've decided to temporarily remove all citations from the Assistant's response
// until we figure out a better design for showing direct sources.
export const renderMessageWithNoCitations = ({
  message,
}: {
  message: string;
}) => {
  return removeCitationText(message);
};
